<template>
  <div>
    <div class="vx-row mt-5">
      <div
        class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-8/12 xl:w-8/12 padding-2"
      >
        <div
          class="bg-white rounded-xl p-6 shadow-[0_2px_4px_rgba(0,0,0,0.04)]"
          style="margin-top: 2px"
        >
          <div class="mb-6">
            <div class="flex items-center justify-between mb-3">
              <div class="flex items-center gap-3">
                <div class="mt-2">
                  <feather-icon icon="SmartphoneIcon" svgClasses="text-dark" />
                </div>
                <span class="text-[15px] font-medium">
                  <h3>{{ $t("customers.label.SIM_Information") }}</h3>
                </span>
              </div>
              <div class="flex items-center my-5">
                <vs-radio
                  v-model="simType"
                  vs-value="Prepaid"
                  class="mr-4"
                  vs-name="radios1"
                >
                  {{ $t("customers.label.Prepaid") }}
                </vs-radio>
                <vs-radio
                  v-model="simType"
                  vs-value="Postpaid"
                  class="mr-4"
                  vs-name="radios1"
                >
                  {{ $t("customers.label.Postpaid") }}
                </vs-radio>
              </div>
            </div>
          </div>
          <hr />
          <div class="mt-4 mb-6">
            <div class="flex justify-between mb-2 mt-6">
              <div>
                <vs-radio
                  v-model="selectedSimType"
                  vs-value="SIM"
                  class="mr-4"
                  vs-name="simTypeRadios"
                >
                  {{ $t("customers.label.Physical_SIM") }}
                </vs-radio>
                <vs-radio
                  v-model="selectedSimType"
                  vs-value="esim"
                  class="mr-4"
                  vs-name="simTypeRadios"
                >
                  {{ $t("customers.label.eSIM") }}
                </vs-radio>
              </div>
            </div>
            <label
              class="flex items-center gap-2"
              v-if="selectedSimType === 'SIM'"
            >
              <input type="checkbox" v-model="applyShipping" />
              <span>Apply shipping charge</span>
            </label>
            <div class="mb-6">
              <div class="mb-4 mt-4">
                <span class="text-[14px] font-medium">{{
                  $t("customers.label.SelectCustomerType")
                }}</span>
                <span class="text-red-500">*</span>
              </div>
              <div>
                <vs-radio
                  v-model="customerType"
                  vs-value="new"
                  class="mb-4"
                  vs-name="customerTypeRadios"
                >
                  {{ $t("customers.label.New_to_Lyca") }}
                </vs-radio>
                <br />
                <vs-radio
                  v-model="customerType"
                  vs-value="transferring"
                  class="mb-4"
                  vs-name="customerTypeRadios"
                >
                  {{ $t("customers.label.TransferringFromPreviousNetwork") }}
                </vs-radio>
                <br />
                <vs-radio
                  v-model="customerType"
                  vs-value="convert"
                  class="mb-4"
                  vs-name="customerTypeRadios"
                >
                  {{ $t("customers.label.Convert_Lyca_Prepaid_to_Postpaid") }}
                </vs-radio>
              </div>
            </div>
            <div v-if="customerType === 'convert'" class="mt-6">
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div
                    class="flex items-top justify-beetween gap-2 convertSection"
                  >
                    <feather-icon
                      title="alertCircleIcon"
                      icon="AlertCircleIcon"
                      svgClasses="w-5 h-5"
                      class="icon_row alertIconSec"
                    />
                    <p>
                      {{
                        $t(
                          "customers.label.Existing_customer_is_going_to_be_sent_a_secure_link_to_confirm_that_they_wish_to_move_from_prepaid_to_abonnement."
                        )
                      }}
                      <span>{{
                        "customers.label.Customer_to_receive_an_SMS"
                      }}</span>
                    </p>
                  </div>
                  <div class="flex items-center gap-2 mt-4">
                    <vs-input
                      :label="$t('customers.label.Lyca_Mobile_Number')"
                      class="mb-2 starlabel"
                      v-model="phoneNumber"
                      :placeholder="
                        $t('customers.label.Enter_the_Lyca_Mobile_Number')
                      "
                    />
                    <vs-button
                      color="success"
                      class="truncate mt-4"
                      size="small"
                      >{{ $t("customers.label.Send_Secure_link") }}</vs-button
                    >
                  </div>
                </div>
              </div>
            </div>
            <vx-card v-if="customerType === 'new'" class="mt-6">
              <ValidationObserver ref="observer1">
                <div class="vx-row">
                  <div class="vx-col w-full flex">
                    <h4>{{ $t("customers.label.New_to_Lyca_Mobile") }}</h4>
                    <span class="ml-2"
                      ><feather-icon
                        icon="HelpCircleIcon"
                        svgClasses="text-dark"
                    /></span>
                  </div>

                  <div
                    class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-8/12 xl:w-8/12 padding-2 mt-3"
                  >
                    <div class="vx-col w-full mt-3">
                      <ValidationProvider
                        rules="required|min:16"
                        v-slot="{ errors }"
                        :name="$t('customers.label.serial_number')"
                      >
                        <vs-input
                          type="number"
                          v-model="serialNumber"
                          :label="$t('customers.label.Serial_Number')"
                          placeholder="XXXX-XXXX-XXXX-XXXX"
                          class="w-full font-semibold mb-6 starlabel"
                          @input="onSerialNumberInput"
                        />
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                    <div class="vx-col w-full mt-3">
                      <!-- <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="pukCode"
                      > -->
                      <ValidationProvider
                        rules="required|numeric"
                        v-slot="{ errors }"
                        :name="$t('customers.label.PUK_Code')"
                      >
                        <vs-input
                          type="text"
                          v-model="pukCode"
                          :label="$t('customers.label.PUK_Code')"
                          :placeholder="
                            $t('customers.label.Enter_the_PUK_Code')
                          "
                          class="w-full font-semibold mb-6 starlabel"
                        />
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span> </ValidationProvider
                      >&nbsp;
                      <span
                        class="validate-error"
                        style="color: red"
                        v-if="pukCode && responsePukCode != pukCode"
                        >{{
                          $t("customers.label.PUK_Code_is_not_matched")
                        }}</span
                      >
                      <!-- </ValidationProvider> -->
                    </div>
                  </div>

                  <div
                    class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-4/12 xl:w-4/12 padding-2"
                  >
                    <div>
                      <img
                        src="@/assets/images/pages/SerialDummy.png"
                        alt="Serial Dummy"
                        width="100%"
                      />
                    </div>
                  </div>
                </div>
              </ValidationObserver>
            </vx-card>
            <vx-card v-if="customerType === 'transferring'" class="mt-6">
              <div class="vx-row">
                <div class="vx-col w-full flex">
                  <h4>{{ $t("customers.label.Switching_to_Lyca_Mobile") }}</h4>
                  <span class="ml-2"
                    ><feather-icon icon="HelpCircleIcon" svgClasses="text-dark"
                  /></span>
                </div>

                <div
                  class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-8/12 xl:w-8/12 padding-2 mt-3"
                >
                  <vs-input
                    type="text"
                    :label="$t('customers.label.Serial_Number')"
                    placeholder="XXXX-XXXX-XXXX-XXXX"
                    class="w-full font-semibold mb-6 starlabel"
                  />
                  <vs-input
                    type="text"
                    :label="$t('customers.label.PUK_Code')"
                    :placeholder="$t('customers.label.Enter_the_PUK_Code')"
                    class="w-full font-semibold mb-1"
                  />
                </div>
                <div
                  class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-4/12 xl:w-4/12 padding-2"
                >
                  <div>
                    <img
                      src="@/assets/images/pages/SerialDummy.png"
                      alt="Serial Dummy"
                      width="100%"
                    />
                  </div>
                </div>
                <div class="vx-col w-full">
                  <div class="transferringBtn mt-4">
                    <vs-button color="success" class="truncate" size="small">{{
                      $t("Continue")
                    }}</vs-button>
                  </div>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
      </div>
      <div
        class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-4/12 xl:w-4/12 padding-2"
      >
        <div class="vx-card basket-card p-4">
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="flex items-center basketSection">
                <img src="@/assets/images/pages/basketIcon.svg" />
                <h3 class="ml-3">{{ $t("customers.label.Basket") }}</h3>
              </div>
            </div>
          </div>
          <div
            class="p-2"
            :style="
              serialNumber && serialNumber.length > 14
                ? {
                    border:
                      elapsedTime > 59
                        ? '4px solid #00FF00'
                        : '4px solid #FF0000',
                  }
                : {}
            "
          >
            <span
              class="font-bold flex items-center justify-between"
              v-if="serialNumber && serialNumber.length > 14"
            >
              This number is reserved for
              <Timer
                style="margin-right: 15px"
                @update-timer="updateElapsedTime"
                :elapsedTime="elapsedTime"
              />
            </span>
            <p class="mb-2 text-success">
              ✅ You Selected {{ selectedSimText }}
            </p>
            <p
              class="mb-2 text-success"
              v-if="serialNumber && serialNumber.length > 14"
            >
              ✅ Serial No -
              {{ serialNumber }}
            </p>
            <p class="mb-2 text-success" v-if="phoneNumber">
              ✅ Phone No -
              {{ phoneNumber || "" }}
            </p>

            <p class="mb-2 mt-2 text-success" v-if="shippingCharge">
              ✅ Shipping Charge:
              {{ shippingPrice }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row justify-end">
      <span class="ml-1 mr-2">
        <vs-button @click="nextTab">
          {{ $t("customers.label.next") }}
        </vs-button>
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import basket from "@/components/basket.vue";
import moment from "moment";
import Timer from "@/components/Timer.vue";
export default {
  name: "SimInformation",
  data() {
    return {
      simType: "Postpaid",
      selectedSimType: "SIM",
      customerType: "new",
      pukCode: "",
      responsePukCode: "",
      serialNumber: "",
      phoneNumber: "",
      timerStarted: false,
      applyShipping: true,
    };
  },
  components: {
    basket,
    ValidationProvider,
    ValidationObserver,
    Timer,
  },
  computed: {
    ...mapState({
      elapsedTime: (state) => state.customerActivationNew.elapsedTime,
      PlanInfo: (state) => state.customerActivationNew.planData,
    }),
    shouldStartTimer() {
      return this.serialNumber && this.serialNumber.length > 14;
    },
    selectedSimText() {
      return this.selectedSimType === "SIM" ? "Physical SIM" : "eSIM";
    },
    shippingCharge() {
      return this.selectedSimType === "SIM" && this.applyShipping
        ? true
        : false;
    },
    shippingPrice() {
      if (!this.PlanInfo.length) return;
      let temp = this.PlanInfo.filter((item) => [362, 415].includes(item.id));
      if (temp.length == 0) {
        return;
      }
      return temp[0].priceDetails[0].finalPrice;
    },
  },
  methods: {
    updateElapsedTime(time) {
      this.$store.commit("customerActivationNew/setElapsedTime", time);
    },
    startTimer() {
      if (this.shouldStartTimer && !this.timerStarted) {
        this.timerStarted = true;
        this.$refs.timer.start();
      }
    },
    async getPlanInfoMethod(planType) {
      const data = {
        locale: "en",
        plantype: planType,
        isprepaid: this.simType === "Prepaid" ? "Y" : "N",
        salesChannel: "POS",
        accessibleOnly: "Y",
      };

      const processedIds = new Set();
      try {
        await this.$store
          .dispatch("customerActivationNew/fetchPlanInfoAction", data)
          .then((res) => {
            const pageItems = res.data.pageItems;
            for (const x of pageItems) {
              if (processedIds.has(x.id)) continue;
              processedIds.add(x.id);
              pageItems.forEach((item) => {
                this.contentData.push(item.documentData);
              });
            }
          });
      } catch (error) {
        throw Error();
        //
      }
    },
    async onSerialNumberInput() {
      if (this.serialNumber && this.serialNumber.length >= 4) {
        try {
          await this.getPostpaidSimMethod();
        } catch (error) {
          console.error("Error in Vuex action:", error.message);
        }
      }
    },
    async getPostpaidSimMethod() {
      const data = {
        search: this.serialNumber,
      };
      try {
        await this.$store
          .dispatch("customerActivationNew/fetchPostpaidAction", data)
          .then((res) => {
            if (
              res &&
              res.data &&
              res.data.InventoryInfo &&
              res.data.InventoryInfo.length > 0
            ) {
              if (
                res &&
                res.data &&
                res.data.InventoryInfo &&
                res.data.InventoryInfo[0].simInfo.packageInfo.packageName.toLowerCase() !==
                  this.simType.toLowerCase()
              ) {
                const message =
                  this.simType === "Prepaid" ? "Postpaid" : "Prepaid";
                this.$toasted.error(`This serial number is ${message}.`, {
                  duration: 3000,
                });
              } else {
                const data =
                  res &&
                  res.data &&
                  res.data.InventoryInfo &&
                  res.data.InventoryInfo[0];
                this.serialNumber = data.unitNo;
                this.phoneNumber = data.msisdn;
                this.responsePukCode = data.puk;
                this.reserveMethod().then(() => {
                  this.$refs.timer.start();
                });
              }
            } else {
              this.$toasted.error(res.data.Response.message, {
                duration: 3000,
              });
            }
          });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    storeBasketData() {
      const basketData = {
        selectedSimText: this.selectedSimText,
        itemSerialNumber: this.serialNumber,
        pairedItemSerialNumber: this.phoneNumber,
        simType: this.simType,
        serialNumber: this.serialNumber,
        phoneNumber: this.phoneNumber,
        timer: this.elapsedTime,
        stage: 1,
      };
      if (this.shippingCharge) {
        basketData.shippingCharge = this.shippingPrice;
      }
      localStorage.setItem("basketData", JSON.stringify(basketData));
      this.$store.dispatch("customerActivationNew/setBasketData", basketData);
    },

    async reserveMethod() {
      const payload = {
        comodityType: this.selectedSimType,
        data: {
          unitNo: this.serialNumber,
          customerId: "9927492496",
          expiryDuration: 900,
        },
      };
      try {
        await this.$store
          .dispatch("customerActivationNew/reserveApiAction", payload)
          .then(() => {
            this.$swal({
              title: "Success",
              text: "This number is reserved for you.",
              icon: "success",
              confirmButtonText: "OK",
            });
          });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async nextTab() {
      const isValid = await this.$refs.observer1.validate();
      if (!isValid || this.responsePukCode != this.pukCode) return;

      let simInfo = {
        simType: this.simType,
        selectedSimType: this.selectedSimText,
        customerType: this.customerType,
        pukCode: this.pukCode,
        serialNumber: this.serialNumber,
        phoneNumber: this.phoneNumber,
        saleDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      };
      this.$store.dispatch(
        "customerActivationNew/customerActivationSimInfo",
        simInfo
      );
      this.storeBasketData();
      this.$router.push("/customers/customer_activation/plan-info");
    },
  },
  watch: {
    elapsedTime(val) {
      if (val === 0) {
        this.serialNumber = "";
        this.phoneNumber = "";
        this.timerStarted = false;
      }
    },

    serialNumber: {
      handler: function (newVal, oldVal) {
        if (
          newVal !== oldVal &&
          this.shouldStartTimer &&
          this.elapsedTime === 0
        ) {
          this.startTimer();
        }
      },
    },
  },
  async mounted() {
    if (this.shouldStartTimer) {
      this.startTimer();
    }
    this.getPlanInfoMethod("AddonPlan");
    localStorage.removeItem("basketData");
    this.$store.dispatch("customerActivationNew/clearCustomerInfoData");
  },
};
</script>

<style scoped>
.basketSection {
  border-bottom: 1px solid #00000026;
  padding-bottom: 10px;
  margin-bottom: 15px;
}

.basket-card {
  height: 300px;
}

.convertSection {
  border: 1px solid #ffa500;
  padding: 10px;
  border-radius: 5px;
  background: #fff5e1;
}

.convertSection .alertIconSec {
  color: #ffa500;
}

.convertSection span {
  display: block;
  margin-top: 15px;
}

.transferringBtn {
  display: flex;
  justify-content: flex-end;
}
</style>
